import { Injectable } from '@angular/core';
import { Observable, EMPTY, of,  tap,map, ReplaySubject } from 'rxjs';
import { HttpClient, HttpParams } from "@angular/common/http";
import { IDropdown } from "@models/dropdown.model";
import { environment } from "@environments/environment";

@Injectable({
  providedIn: "root",
})
export class DropdownsService {

  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) {}

  getStates(searchParams: any): Observable<IDropdown[]> { // TODO type
    let params = new HttpParams()
      .set('search', searchParams);

     return this.http.get<IDropdown[]>(`${this.apiUrl}/Dropdown/states`, { params });
  }

  getOrganizationTypes(searchParams: any): Observable<IDropdown[]> {
    let params = new HttpParams()
      .set('search', searchParams);
    return this.http.get<IDropdown[]>(`${this.apiUrl}/Organization/types`, { params: params });
  }

  getUserRoles(searchParams: any):Observable<IDropdown[]> {
    let params = new HttpParams()
      .set('search', searchParams);
    return this.http.get<IDropdown[]>(`${this.apiUrl}/Users/roles`, { params: params });
  }
}
